module.exports = __webpack_public_path__ + "img/portal_loading.1904fa53.gif";